
// Service Worker utility functions for cache management
export const invalidateServiceWorkerCache = async (patterns?: string[]) => {
  if ('serviceWorker' in navigator && 'caches' in window) {
    try {
      const cacheNames = await caches.keys();
      
      for (const cacheName of cacheNames) {
        if (cacheName.includes('supabase-realtime-api-cache') || cacheName.includes('supabase-api-cache')) {
          const cache = await caches.open(cacheName);
          
          if (patterns) {
            // Invalidate specific patterns
            const keys = await cache.keys();
            for (const request of keys) {
              if (patterns.some(pattern => request.url.includes(pattern))) {
                await cache.delete(request);
              }
            }
          } else {
            // Clear entire cache
            await caches.delete(cacheName);
          }
        }
      }
      
      console.log('✅ Service worker cache invalidated');
    } catch (error) {
      console.error('❌ Failed to invalidate service worker cache:', error);
    }
  }
};

export const forceRefreshServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        // Force update the service worker
        await registration.update();
        
        // Skip waiting if there's a waiting service worker
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      }
    } catch (error) {
      console.error('❌ Failed to refresh service worker:', error);
    }
  }
};

// Clear cache for specific data types when real-time updates occur
export const invalidateCacheForRealTimeUpdate = async (dataType: string, id?: string) => {
  const patterns = [];
  
  switch (dataType) {
    case 'matches':
      patterns.push('/rest/v1/matches', '/rest/v1/match_players');
      break;
    case 'groups':
      patterns.push('/rest/v1/groups', '/rest/v1/group_members');
      if (id) patterns.push(`group_id=eq.${id}`);
      break;
    case 'notifications':
      patterns.push('/rest/v1/notifications');
      break;
    case 'messages':
      patterns.push('/rest/v1/messages', '/rest/v1/conversations');
      break;
    case 'tournaments':
      patterns.push('/rest/v1/tournaments', '/rest/v1/tournament_');
      break;
    default:
      patterns.push('/rest/v1/');
  }
  
  await invalidateServiceWorkerCache(patterns);
};
